import {Endpoints} from '../../globals/api/endpoints';

export class SubscriptionCouponEndpoints extends Endpoints {

  public static readonly ADD_COUPON = SubscriptionCouponEndpoints.VIEWER + '/subscription-coupon';
}
